import { Inbox } from "lucide-react";

export const EmptyDetailState = () => (
  <div className="flex-1 flex items-center justify-center p-10">
    <div className="max-w-md text-center animate-fade-up">
      <Inbox className="w-8 h-8 text-muted-foreground mx-auto mb-3" />
      <h3 className="font-heading text-2xl font-black tracking-tighter mb-2">No incident selected</h3>
    </div>
  </div>
);
